module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "save-view",
    on: {
      "submit": _vm.save
    }
  }, [((_vm.state == 'ready') || (_vm.state == 'working')) ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    ref: "fileName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "fileName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.fileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "fileName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().fileNamePlaceholder))])]), _vm._v(" "), _c('div', {
    staticClass: "file-list-holder"
  }, [_c('FileList', {
    attrs: {
      "contentType": _vm.contentType
    },
    on: {
      "selected": _vm.selected
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.state == 'ready' || _vm.state == 'working') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v(" " + _vm._s(_vm.i18n().saveToCloud) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.download
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")]), _vm._v(" " + _vm._s(_vm.i18n().download) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e(), _vm._v(" "), (_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand done"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n().fileSaved(_vm.fileName)))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'error') ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand error"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n().saveError(_vm.error)))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'error' || _vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("done")]), _vm._v(" " + _vm._s(_vm.i18n().ok) + "\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-184a216c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/save/SaveView.vue
// module id = 435
// module chunks = 0